import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { useAppContext } from 'hooks/useAppContext';
import { IDeposit } from 'interfaces/profile.interface';
import React, { FC } from 'react';
import { useTruckerNavigation } from 'hooks/useNavigation';
import * as Styled from './styled';

const Footer: FC<Partial<IDeposit>> = ({ proposalId }) => {
  const {
    state: {
      profileSize: { isProfileSizeSmall },
    },
  } = useAppContext();

  const { handleNavigation } = useTruckerNavigation();

  const handleDiscard = () => {
    handleNavigation(`pre-viagem/${proposalId}/recusa`);
  };

  const handleConfirm = () => {
    handleNavigation(`pre-viagem/${proposalId}/aceite`);
  };

  return (
    <Styled.Wrapper data-testid="deposit-footer" isMobile={isProfileSizeSmall}>
      <FuelTypography weight="medium">Fechou com esse motorista?</FuelTypography>

      <FuelFlex defaultProps={{ gap: 'km3', alignItems: 'center', width: isProfileSizeSmall ? '100%' : 'unset' }}>
        <FuelButton
          variant="tertiary"
          onClick={handleDiscard}
          data-testid="discard-button"
          fullWidth={isProfileSizeSmall}
          size="large"
        >
          Não fechei
        </FuelButton>
        <FuelButton onClick={handleConfirm} data-testid="confirm-button" fullWidth={isProfileSizeSmall} size="large">
          Sim, fechei
        </FuelButton>
      </FuelFlex>
    </Styled.Wrapper>
  );
};

export default Footer;
